export const osnDoNotEnterIcon = {
  // eslint-disable-next-line max-len
  data: `<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="37" cy="37" r="34" stroke="white" stroke-width="6" /><line x1="11.8787" y1="60.8787" x2="58.8787" y2="13.8787" stroke="white" stroke-width="6" /></svg>;`,
  name: 'do-not-enter',
};
